<div class="img" [matTooltip]="text">
    <ng-content></ng-content>
</div>
